import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import WixSDK from 'shared/utils/wix-sdk';

const ACTIONS = createAsyncActions('SERVER.USERS.CURRENT-SITE-USER');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function() {
  return function(dispatch) {
    const uid = WixSDK.Utils.getUid();

    dispatch(START());

    if (!uid) {
      return Promise.resolve().then(() => dispatch(SUCCESS()));
    }

    return WixSDK.currentMember().then(
      function(currentUserData) {
        dispatch(SUCCESS({}, currentUserData));
        return currentUserData;
      },

      function(response) {
        dispatch(FAIL({}, response));
      },
    );
  };
}
